import React, { useEffect, useState } from "@wordpress/element";
import { useRange, UseRangeProps } from "react-instantsearch";

import Slider from "rc-slider";

type RangeSliderProps = { title?: string } & UseRangeProps;

export function RangeSlider(props: RangeSliderProps) {
  const { start, range, canRefine, refine } = useRange(props);
  const { min, max } = range;
  const [value, setValue] = useState([min, max]);

  const from = Math.max(min, Number.isFinite(start[0]) ? start[0] : min);
  const to = Math.min(max, Number.isFinite(start[1]) ? start[1] : max);

  useEffect(() => {
    setValue([from, to]);
  }, [from, to]);

  const handleChange = (value: number | number[]) => {
    if (Array.isArray(value)) {
      setValue(value);
    } else {
      setValue([value]); // ou ignore selon ton besoin
    }
  };

  return (
    <div className="refinement-list">
      <h4 className="refinement-list__header">
        <span className="refinement-list__title">{props.title}</span>
      </h4>
      <div className="ranger">
        <span className="range-label">{value[0]}</span>
        <Slider
          range
          min={min}
          max={max}
          value={value}
          onChange={handleChange}
          onChangeComplete={refine}
        ></Slider>
        <span className="range-label">{value[1]}</span>
      </div>
    </div>
  );
}
